import { LazyImport, LazyModule, createLazyComponent } from 'owa-bundling';
import { runAfterBootstrap } from 'owa-delayed-initialization';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "MailSearch", webpackPrefetch: true */ './lazyIndex');
});
// Register mutators
import './mutators/searchBoxWidthMutators';
// Export components
export { default as MailSearchBoxContainer } from './components/MailSearchBoxContainer';
// Export lazy loaded components
export var SearchRefiners = createLazyComponent(lazyModule, function (m) { return m.SearchRefiners; });
export { SUPPORTED_FILESHUB_SUGGESTION_KIND_LIST, } from './store/schema/constants';
export { default as mailSearchStore, defaultMailSearchStore, getStore } from './store/store';
// Export actions
export { clearSearchScope, loadMessageSuggestionIntoTable, loadTableViewFromSearchTableQuery, removeSearchTableFromStore, selectPreviousNode, setStaticSearchScope, } from './actions/publicActions';
export var lazySetStaticSearchScopeData = new LazyImport(lazyModule, function (m) { return m.setStaticSearchScopeData; });
// Export lazy loaded actions
export var lazyRegisterSearchStoreOrchestrators = new LazyImport(lazyModule, function (m) { return m.registerSearchStoreOrchestrators; });
export var lazyStartSearchWithCategory = new LazyImport(lazyModule, function (m) { return m.startSearchWithCategory; });
// Export selectors
export { default as shouldCenterSearchBox } from './selectors/shouldCenterSearchBox';
// Export from owa-persona
export var lazyInitializeLivePersonaCard = new LazyImport(lazyModule, function (m) { return m.initializeLivePersonaCard; });
export var lazyPersonaControlStore = new LazyImport(lazyModule, function (m) { return m.personaControlStore; });
runAfterBootstrap(function () {
    lazyRegisterSearchStoreOrchestrators.import();
});
// Export utils
export { default as getFolderIdFromTableView } from './utils/getFolderIdFromTableView';
//# sourceMappingURL=index.js.map